import React, { useState, useEffect } from "react";
import { Toast } from "primereact/toast";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { useDispatch, useSelector } from "react-redux";
import "react-pdf/dist/Page/TextLayer.css";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { useLocation, useNavigate } from "react-router-dom";
import RenderToast from "../../componentes/RenderToast";
import { Message } from "primereact/message";
import {
  validarDocumentoQR,
  setValidarDocumento,
  setMessageError,
} from "../../sliceRedux/Documento.slice";

import { Checkbox } from "primereact/checkbox";

pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.296/build/pdf.worker.mjs";

const ValidarDocumento = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [numPages, setNumPages] = useState(1);
  const toast = React.createRef();
  const messageError = useSelector((state) => state.documento.messageError);
  const validarDocumento = useSelector((state) => state.documento.validarDocumento);
  const searchParams = new URLSearchParams(location.search);
  const [checked, setChecked] = useState(false);
  const [pdfURL, setPdfURL] = useState("");
  const [pageWidth, setPageWidth] = useState(0);

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    const codigoDocumento = searchParams?.get("idDoc");
    const ruc = searchParams?.get("ruc");
    if (!codigoDocumento || !ruc) {
      navigate("/403");
    } else {
      showLoader();
      dispatch(validarDocumentoQR(codigoDocumento, ruc));
    }

    //Inactivar atajos de teclado
    const handleKeyDown = (event) => {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === "p" ||
          event.key === "P" ||
          event.key === "s" ||
          event.key === "S" ||
          event.key === "u" ||
          event.key === "U")
      ) {
        event.preventDefault();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageWidth(window.innerWidth);
  }

  useEffect(() => {
    if (validarDocumento.code === 200) {
      base64ToPdf(validarDocumento?.object?.bytesArchivo ?? null);
      hideLoader();
    }
    return () => {
      dispatch(setValidarDocumento({ ...validarDocumento, code: 0 }));
    };
  }, [validarDocumento.code]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const base64ToPdf = (base64) => {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfURL(url);
    } catch (error) {
      console.error("Error creando PDF:", error);
      return { blob: null, url: "" };
    }
  };

  return (
    <div onContextMenu={handleContextMenu}>
      {loader}
      <Toast ref={toast} />
      <style>{`
        @media print {
          body { display: none !important; }
        }
      `}</style>

      <div className="flex justify-content-center">
        <Message
          severity="warn"
          text='El documento que está validando mediante el código QR, debe ser similar al presentado excepto los datos de "Documento generado por:" y "Fecha de generación del documento:", los cuales se encuentran en la parte inferior del documento.'
        />
      </div>

      <div className="flex justify-content-center">
        <div className="mt-2">
          <Checkbox onChange={(e) => setChecked(e.checked)} checked={checked} />
          <label htmlFor="selection" className="ml-2">
            Ver documento
          </label>
        </div>
      </div>
      {checked && pdfURL && (
        <div className="viewer-container flex justify-content-center py-3">
          <Document
            file={pdfURL}
            onLoadSuccess={onDocumentLoadSuccess}
            renderMode="canvas"
            loading={"Cargando..."}
          >
            {Array.from({ length: numPages }, (_, index) => (
              <div key={index}>
                {index > 0 && <div>&nbsp;</div>}
                <Page
                  pageNumber={index + 1}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                  width={Math.max(pageWidth * 0.6, 390)}
                />
              </div>
            ))}
          </Document>
        </div>
      )}
    </div>
  );
};

export default ValidarDocumento;
